module.exports = __webpack_public_path__ + "img/icon8.b39ea221.png";